module.exports = __webpack_public_path__ + "assets/img/Blue-Microphones-Langing-page-w960.cae6cc43.jpg";